import React, { useEffect, useRef, useState } from 'react'
import $ from "jquery";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import jszip from "jszip";
import { Link } from 'react-router-dom';
pdfMake.vfs = pdfFonts.vfs;
const Rentee = () => {
    const [activeTab, setActiveTab] = useState("pending");

    const activeToggle = (tab) => {
        setActiveTab(tab);
    };

    const table1 = useRef(null);

    useEffect(() => {
        window.JSZip = jszip;

        let table11, table12;

        if (table1.current) {
            table11 = $(table1.current).DataTable({
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }


        return () => {
            if (table11) table11.destroy();
            if (table12) table12.destroy();
        };
    }, []);

    return (
        <>
            <div className="page-wrapper">
                <div className="page-content p-4">
                    <div className="page-breadcrumb d-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Reported Profiles</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Reported Profiles</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="card radius-10">
                        <div className="entries-wrapper mb-3">
                            <label className="entries-label">
                                <span>Showing</span>
                                <select className="entries-select">
                                    <option value={10} selected>10</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                                <span>Entries</span>
                            </label>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-striped table-bordered align-middle text-center mb-0" ref={table1}>
                                    <thead className="table-light">
                                        <tr>
                                            <th>First Name</th>
                                            <th>Last Name</th>
                                            <th>Category</th>
                                            <th>Joining Date</th>
                                            <th>SEE</th>
                                            <th>Subscription Plan</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>John</td>
                                            <td>Doe</td>
                                            <td>Harassment</td>
                                            <td>Jan 02, 2026</td>
                                            <td>20</td>
                                            <td>
                                                <select className="status-select" disabled>
                                                    <option selected>Basic</option>
                                                </select>
                                            </td>
                                            <td>
                                                <ul className="tbl_actions_wrap d-flex align-items-center gap-2 mb-0 list-unstyled">
                                                    <li>
                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#view_modal">
                                                            <i className="lni lni-eye" title="View" />
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#blockUserModal">
                                                            <i className="bx bx-block" title="Block" />
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Sarah</td>
                                            <td>Smith</td>
                                            <td>Spam</td>
                                            <td>Feb 03, 2026</td>
                                            <td>15</td>
                                            <td>
                                                <select className="status-select" disabled>
                                                    <option selected>Premium</option>
                                                </select>
                                            </td>
                                            <td>
                                                <ul className="tbl_actions_wrap d-flex align-items-center gap-2 mb-0 list-unstyled">
                                                    <li>
                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#view_modal">
                                                            <i className="lni lni-eye" title="View" />
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#blockUserModal">
                                                            <i className="bx bx-block" title="Block" />
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Michael</td>
                                            <td>Johnson</td>
                                            <td>Impersonation</td>
                                            <td>Feb 05, 2026</td>
                                            <td>8</td>
                                            <td>
                                                <select className="status-select" disabled>
                                                    <option selected>Free</option>
                                                </select>
                                            </td>
                                            <td>
                                                <ul className="tbl_actions_wrap d-flex align-items-center gap-2 mb-0 list-unstyled">
                                                    <li>
                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#view_modal">
                                                            <i className="lni lni-eye" title="View" />
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#blockUserModal">
                                                            <i className="bx bx-block" title="Block" />
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Olivia</td>
                                            <td>Brown</td>
                                            <td>Explicit Content</td>
                                            <td>Feb 06, 2026</td>
                                            <td>12</td>
                                            <td>
                                                <select className="status-select" disabled>
                                                    <option selected>Basic</option>
                                                </select>
                                            </td>
                                            <td>
                                                <ul className="tbl_actions_wrap d-flex align-items-center gap-2 mb-0 list-unstyled">
                                                    <li>
                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#view_modal">
                                                            <i className="lni lni-eye" title="View" />
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#blockUserModal">
                                                            <i className="bx bx-block" title="Block" />
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>

                        </div>
                    </div>
                </div>
            </div>


            <div>
                <div className="modal fade" id="blockUserModal" tabIndex={-1} aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirmation alert!</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" />
                            </div>
                            <div className="modal-body">
                                <label className="form-label">Reason for blocking:</label>
                                <textarea className="form-control" rows={3} placeholder="Enter reason..." defaultValue={""} />
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-decline" data-bs-dismiss="modal">Cancel</button>
                                <button id="confirmBlockBtn" className="btn btn-approve text-white px-4"> Block</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="view_modal" tabIndex={-1} aria-labelledby="ticketModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header d-flex justify-content-between align-items-center">
                                <h5 className="modal-title" id="ticketModalLabel">View Report</h5>
                                <div>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" />
                                </div>
                            </div>
                            <div className="modal-body">
                                <div className="profile_modal_wrap">
                                    <div className="main-body">
                                        <form>
                                            {/* Reported User */}
                                            <div className="row mb-3 align-items-center">
                                                <div className="col-sm-3"><h6 className="mb-0">Reported User</h6></div>
                                                <div className="col-sm-9">
                                                    <Link to="user-management-detail.html" className="fw-semibold text-decoration-none fs-6">@johndoe</Link>
                                                </div>
                                            </div>
                                            <div className="row mb-3 align-items-center">
                                                <div className="col-sm-3"><h6 className="mb-0">Category</h6></div>
                                                <div className="col-sm-9">
                                                    <input type="text" className="form-control" readOnly defaultValue="Harassment" />
                                                </div>
                                            </div>
                                            <div className="row mb-3 align-items-center">
                                                <div className="col-sm-3"><h6 className="mb-0">Joining Date</h6></div>
                                                <div className="col-sm-9">
                                                    <input type="text" className="form-control" readOnly defaultValue="Feb 05, 2026" />
                                                </div>
                                            </div>
                                            <div className="row mb-3 align-items-center">
                                                <div className="col-sm-3"><h6 className="mb-0">SEE</h6></div>
                                                <div className="col-sm-9">
                                                    <input type="text" className="form-control" readOnly defaultValue={20} />
                                                </div>
                                            </div>
                                            <div className="row mb-3 align-items-center">
                                                <div className="col-sm-3"><h6 className="mb-0">Subscription Plan</h6></div>
                                                <div className="col-sm-9">
                                                    <input type="text" className="form-control" readOnly defaultValue="Basic" />
                                                </div>
                                            </div>
                                            <div className="row mb-3 align-items-start">
                                                <div className="col-sm-3"><h6 className="mb-0">Detailed Notes</h6></div>
                                                <div className="col-sm-9">
                                                    <textarea className="form-control" rows={4} readOnly defaultValue={"User reported harassment via messages.\nIncludes abusive language and threats.\n                                    "} />
                                                </div>
                                            </div>
                                            <div className="row mb-3 align-items-start">
                                                <div className="col-sm-3"><h6 className="mb-0">Attachments</h6></div>
                                                <div className="col-sm-9 d-flex flex-wrap gap-3">
                                                    <div className="position-relative attachment-img">
                                                        <img src="images/main-page/doxo.png" className="rounded border" width={120} height={120} alt="Attachment" />
                                                    </div>
                                                    <div className="position-relative attachment-img">
                                                        <img src="images/main-page/doxo.png" className="rounded border" width={120} height={120} alt="Attachment" />
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Rentee